import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { isEmpty, cloneDeep } from 'lodash'

import { TextField, Box, Stack } from '@mui/material'

import { DateTimeRangePicker, getDriverMapFieldList } from '../map/helper/functions'
import DashboardList from '../DashboardKeyList'
import OtherOptions from 'components/pages/dis-v2/_components/OtherOptions'

export default function DriverEventsForm(props) {
	const {
		filterData,
		dashboardKeyList,
		onFilterDataChange,
		additionalSettingComponent,
		tileLabelComponent,
		otherOptions = [],
	} = props
	const { t } = useTranslation('common')
	const hasOtherOptions = useMemo(() => !isEmpty(otherOptions), [otherOptions])

	const fieldList = useMemo(() => getDriverMapFieldList(t), [t])
	return (
		<Stack spacing={2}>
			<TextField
				size="small"
				id="userEmail"
				label={'User email'}
				value={filterData.eventData?.userEmail}
				onChange={(e) => {
					const value = e.target.value
					onFilterDataChange('eventData', { ...filterData.eventData, userEmail: value })
				}}
				InputLabelProps={{
					shrink: true,
				}}
			/>

			<DateTimeRangePicker
				fromDate={filterData.eventData?.fromDate}
				toDate={filterData.eventData?.toDate}
				onFilters={(name, value) =>
					onFilterDataChange('eventData', { ...filterData.eventData, [name]: value })
				}
			/>

			{additionalSettingComponent && additionalSettingComponent}

			<Box sx={{ marginTop: additionalSettingComponent ? `0 !important` : null }}>
				<DashboardList
					title={t('common:dis.dashboardKeys')}
					list={dashboardKeyList}
					fields={fieldList}
					onFieldsChange={(id, value) => {
						if (isEmpty(value)) {
							const currentLinkedFields = cloneDeep(filterData?.linkedFields)
							if (currentLinkedFields[id]) {
								delete currentLinkedFields[id]
							}
							onFilterDataChange('linkedFields', currentLinkedFields)
							return
						}
						onFilterDataChange('linkedFields', { ...filterData.linkedFields, [id]: value })
					}}
					linkedFields={filterData.linkedFields || {}}
					getLabelOption={(item) => item.label}
				/>
			</Box>

			{tileLabelComponent && tileLabelComponent}

			{hasOtherOptions && (
				<OtherOptions
					optionList={otherOptions}
					checkedOptions={filterData?.otherOptionsChecked || ['enableExport']}
					onChangeOptions={(value) => onFilterDataChange('otherOptionsChecked', value)}
					hideScroll={true}
					marginTopTitle={false}
				/>
			)}
		</Stack>
	)
}
